"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.withUncontrolled = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireWildcard(require("react"));
var _excluded = ["defaultHidden", "isHidden", "onClick"];
/**
 * withUncontrolled is a HOC that enhances ShowHide and ShowHideWordCount
 * with default prop values to handle uncontrolled use cases.
 *
 * This could be potentially extended and used across all other components
 * that need to have uncontrolled prop values.
 */
var withUncontrolled = function withUncontrolled(Component) {
  var WithUncontrolled = function WithUncontrolled(_ref) {
    var defaultHidden = _ref.defaultHidden,
      controlledHidden = _ref.isHidden,
      onClick = _ref.onClick,
      rest = (0, _objectWithoutProperties2.default)(_ref, _excluded);
    var _useState = (0, _react.useState)(defaultHidden),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      uncontrolledHidden = _useState2[0],
      setUncontrolledHidden = _useState2[1];
    var isHidden = typeof controlledHidden !== 'undefined' ? controlledHidden : uncontrolledHidden;
    var onClickCallback = (0, _react.useCallback)(function (nextValue) {
      setUncontrolledHidden(!nextValue);
      if (typeof onClick === 'function') {
        onClick(typeof controlledHidden !== 'undefined' ? nextValue : !nextValue);
      }
    }, [controlledHidden, onClick]);
    return /*#__PURE__*/_react.default.createElement(Component, (0, _extends2.default)({
      isHidden: isHidden,
      onClick: onClickCallback
    }, rest));
  };
  WithUncontrolled.displayName = "" + (Component.displayName || Component.name || 'Component');
  WithUncontrolled.Hidden = Component.Hidden || null;
  WithUncontrolled.propTypes = process.env.NODE_ENV !== "production" ? {
    defaultHidden: _propTypes.default.bool
  } : {};
  WithUncontrolled.defaultProps = {
    defaultHidden: true
  };
  return WithUncontrolled;
};
exports.withUncontrolled = withUncontrolled;